var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKibana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 52 65",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24v33.58l23.87-27.5A49.82 49.82 0 0 0 0 24z",
    fill: "#343741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v24a49.82 49.82 0 0 1 23.87 6.09L50 0z",
    fill: "#f04e98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 33.3L2.37 64H49a50 50 0 0 0-20-30.69z",
    fill: "#00bfb3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKibana);
export default __webpack_public_path__ + "static/media/kibana.263cfee5e9b227e4ceddc0de591180dc.svg";
export { ForwardRef as ReactComponent };